module.exports = __webpack_public_path__ + "static/img/R.8887d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/R.png
// module id = cxIw
// module chunks = 0